import API from "../../../../../axios";

export const getCostCampaign = async (
  channelId,
  countryStats,
  templateCategory,
) => {
  try {
    const response = await API.post("/campaign/calculate-cost", {
      channelId: channelId,
      messages: countryStats,
      template: templateCategory === "MARKETING" ? "Marketing" : "Utility",
    });

    return {
      data: response.data,
      error: null,
    };
  } catch (error) {
    return {
      data: null,
      error: error,
    };
  }
};
